import { NavItem } from '@/components/layout/nav-item'
import { buildYoutubeUrl, checkEnv } from '../lib/utils/utils'
import { I18nValue, LangCode } from '@/components/i18n/lang-context'

export const SITE_IS_PROD = !process.env.NEXT_PUBLIC_SITE_IS_PROD || process.env.NEXT_PUBLIC_SITE_IS_PROD !== 'true' ? false : true
export const SITE_IS_JBDA = checkEnv(process.env.NEXT_PUBLIC_SITE, 'NEXT_PUBLIC_SITE') === 'jbda'
export const SITE_IS_LB = checkEnv(process.env.NEXT_PUBLIC_SITE, 'NEXT_PUBLIC_SITE') === 'lb'

const JBDA_NAV_ITEMS: NavItem[] = []

const LB_NAV_ITEMS: NavItem[] = [
  {
    title: { en: 'Our Solution', fr: 'Notre solution' },
    subs: [
      {
        title: { en: 'How it works', fr: 'Comment ça marche' },
        href: '/#howItWorks',
        iconName: 'logo'
      },
      {
        title: { en: 'They Trust Us', fr: 'Ils nous font confiance' },
        href: '/partners',
        scrollBefore: true,
        iconName: 'thumbup'
      },
      {
        title: { en: 'They talk about us', fr: 'Ils parlent de nous' },
        href: '/press',
        scrollBefore: true,
        iconName: 'press'
      },
      {
        title: { en: 'Our Team', fr: 'Notre équipe' },
        href: '/about-us',
        iconName: 'about'
      }
    ]
  },
  {
    title: { en: 'For Whom?', fr: 'Pour qui ?' },
    subs: [
      {
        title: { en: 'Crypto Owners', fr: 'Détenteurs de crypto' },
        href: '/landing/targets/crypto',
        iconName: 'crypto'
      },
      {
        title: { en: 'Real Estate Professionals', fr: 'Professionnels de l\'immobilier' },
        href: '/landing/targets/immo',
        iconName: 'immo'
      },
      {
        title: { en: 'Regulated Professionals', fr: 'Professions réglementées' },
        href: '/landing/targets/regulated',
        iconName: 'regulated'
      }
    ]
  },
  {
    title: { en: 'For What?', fr: 'Pour quoi ?' },
    subs: [
      {
        title: { en: 'Real Estate Purchase', fr: 'Achat Immobilier' },
        href: '/landing/usages/immo',
        iconName: 'home'
      }
    ]
  },
  {
    title: { en: 'Resources', fr: 'Ressources' },
    subs: [
      {
        title: { en: 'Blog', fr: 'Blog' },
        href: '/blog',
        iconName: 'blog'
      },
      {
        title: { en: 'FAQ', fr: 'FAQ' },
        href: '/faq',
        iconName: 'faq'
      },
      {
        title: { en: 'Glossary', fr: 'Glossaire' },
        href: '/glossary',
        iconName: 'glossary'
      }
    ]
  }
]


/**
 * Site Config for JBDA SITE
 */
export const siteConfigJBDA = {
  appName: 'JBDA',
  descriptionHtml: 'JBDA : Simplifier l’investissement crypto dans l’économie réelle. - Sécurisez Vos Transactions Immobilières et Mobilières en investissant sereinement vos cryptomonnaies dans l\'économie réelle.',
  links: {
    linkedin: 'https://www.linkedin.com/company/jbda-associ%C3%A9s',
    linkedinId: '104058917',
    twitterHandle: '',
    youtubeChannel: '',
    youtubeChannelId: ''
  },
  logo: {
    app: '/jbda/JBDA_logo_picto_couleur_rvb.png',
    appWhite: '/jbda/JBDA_logo_picto_blanc_rvb.png',
    vertical: '/jbda/JBDA_logo_vertical_couleur_rvb.png',
    verticalWhite: '/jbda/JBDA_logo_vertical_blanc_rvb.png',
    verticalBj: null,
    horizontal: '/jbda/JBDA_logo_horizontal_couleur_rvb.png',
    horizontalWhite: '/jbda/JBDA_logo_horizontal_blanc_rvb.png',
    horizontalBj: null,
    horizontalBjRatio2_1: '/jbda/JBDA_logo_horizontal_couleur_rvb_ratio_2_1.png',
    horizontalBjWhite: null
  },
  mail: {
    subjectPrefix: '[JBDA]'
  },
  consentCookie:'jbda-consent',
  navItems: JBDA_NAV_ITEMS
}

/**
 * Site Config for LB SITE
 */
export const siteConfigLB = {
  appName: 'Legibloq',
  descriptionHtml: 'Legibloq : Sécurisez Vos Transactions Immobilières et Mobilières en investissant sereinement vos cryptomonnaies dans l\'économie réelle.',
  links: {
    linkedin: 'https://www.linkedin.com/showcase/legibloq',
    linkedinId: '104058954',
    twitterHandle: 'Legibloq',
    youtubeChannel: 'Legibloq_by_JBDA',
    youtubeChannelId: 'UCsqifW2qz6hXYPjXnthkkhg'
  },
  logo: {
    app: '/lb/Legibloq_logo_picto_couleur_rvb.png',
    appWhite: '/lb/Legibloq_logo_picto_blanc_rvb.png',
    vertical: '/lb/Legibloq_logo_vertical_bj_couleur_rvb.png',
    verticalWhite: '/lb/Legibloq_logo_vertical_bj_blanc_rvb.png',
    verticalBj: '/lb/Legibloq_logo_vertical_bj_couleur_rvb.png',
    horizontal: '/lb/Legibloq_logo_horizontal_couleur_rvb.png',
    horizontalWhite: '/lb/Legibloq_logo_horizontal_blanc_rvb.png',
    horizontalBj: '/lb/Legibloq_logo_horizontal_bj_couleur_rvb.png',
    horizontalBjRatio2_1: '/lb/Legibloq_logo_horizontal_bj_couleur_rvb_ratio_2_1.png',
    horizontalBjWhite: '/lb/Legibloq_logo_horizontal_bj_blanc_rvb.png'
  },
  mail: {
    subjectPrefix: '[Legibloq]'
  },
  consentCookie:'lb-consent',
  navItems: LB_NAV_ITEMS
}

// Select the SITE_CONFIG based on the SITE env var
const SITE_CONFIG = SITE_IS_JBDA ? siteConfigJBDA : siteConfigLB

/**
 * Site Config
 */
const SITE_URL = checkEnv(process.env.NEXT_PUBLIC_SITE_URL, 'NEXT_PUBLIC_SITE_URL') as string
export const siteConfig = {
  appId: 'jbda-lb',
  appName: SITE_CONFIG.appName,
  descriptionHtml: SITE_CONFIG.descriptionHtml,
  company: {
    legalName: 'JBDA',
    siren: '982640120',
    siret: '98264012000019',
    vatNumber: 'FR65982640120',
    juridicalForm: 'SAS',
    capital: '10000',
    foundingDate: '2023-12-11',
    activity: 'Autres activités de soutien aux entreprises n.c.a.',
    nafCode: '82.99Z'
  },
  address: {
    streetAddress: 'PEARL PARTNER - BAT3 535 ROUTE DES LUCIOLES',
    addressLocality: 'Valbonne',
    postalCode: '06560',
    addressRegion: 'Provence-Alpes-Côte d\'Azur',
    addressCountry: 'FR'
  },
  geo: {
    latitude: 43.617249,
    longitude: 7.049721
  },
  links: {
    github: 'https://github.com/jarvix-src/jvx-template',
    linkedin: SITE_CONFIG.links.linkedin,
    linkedinId: SITE_CONFIG.links.linkedinId,
    twitterHandle: SITE_CONFIG.links.twitterHandle,
    youtubeChannel: SITE_CONFIG.links.youtubeChannel,
    youtubeChannelId: SITE_CONFIG.links.youtubeChannelId,
    jarvix: 'https://www.jarvix.com',
    bda: 'https://bruzzodubucq.com',
    site: SITE_URL,
    jbda: process.env.NEXT_PUBLIC_SITE_JBDA_URL || (SITE_IS_JBDA ? SITE_URL : '/jbda'),
    legibloq: process.env.NEXT_PUBLIC_SITE_LB_URL || (SITE_IS_LB ? SITE_URL : '/lb')
  },
  logo: {
    app: SITE_CONFIG.logo.app,
    appWhite: SITE_CONFIG.logo.appWhite,
    vertical: SITE_CONFIG.logo.vertical,
    verticalWhite: SITE_CONFIG.logo.verticalWhite,
    horizontal: SITE_CONFIG.logo.horizontal,
    horizontalWhite: SITE_CONFIG.logo.horizontalWhite,
    horizontalBj: SITE_CONFIG.logo.horizontalBj,
    horizontalBjRatio2_1: SITE_CONFIG.logo.horizontalBjRatio2_1,
    horizontalBjWhite: SITE_CONFIG.logo.horizontalBjWhite,
    jarvix: '/jarvix_logo_264x264_transparent.png',
    jarvixVertical: '/jarvix_logo_rvb_1a_vertical_couleur.png',
    jarvix64: '/_next/image?url=%2Fjarvix_logo_264x264_transparent.png&w=64&q=75',
    bdVertical: '/logo-bruzzodubucq.png'
  },
  mail: {
    subjectPrefix: SITE_CONFIG.mail.subjectPrefix,
    contactAddress: process.env.NEXT_PUBLIC_CONTACT_ADDRESS ||'contact@jbda.io',
    newsletterAddress: process.env.NEXT_PUBLIC_NEWSLETTER_ADDRESS ||'contact+newsletter@jbda.io',
    privacyAddress: process.env.NEXT_PUBLIC_PRIVACY_ADDRESS ||'contact+privacy@jbda.io',
    jarvixContactAddress: 'contact@jarvix.com'
  },
  google: {
    gtmId: process.env.NEXT_PUBLIC_GOOGLE_GTM_ID,
    gaId: process.env.NEXT_PUBLIC_GOOGLE_GA_ID,
    mapApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
  },
  video: {
    howTo: {
      fr: process.env.NEXT_PUBLIC_YOUTUBE_VIDEO_FR || '',
      en: process.env.NEXT_PUBLIC_YOUTUBE_VIDEO_EN || ''
    },
    rent2025: {
      fr: 'PhJTBAzktWM'
    }
  },
  calendar: {
    fr: process.env.NEXT_PUBLIC_KOALENDAR_FR || '',
    en: process.env.NEXT_PUBLIC_KOALENDAR_EN || ''
  },
  consentCookie: SITE_CONFIG.consentCookie,
  navItems: SITE_CONFIG.navItems,
  phone: '+33 (0)7 49 05 35 47'
}

const getLocalizedEntry = (siteConfigEntry: I18nValue, langCode: LangCode) => {
  let url = siteConfigEntry[langCode]
  // Default to EN unless requested language is EN and does not exists, then falls back to FR
  if(!url)
    url = langCode === 'en' ? siteConfigEntry['fr'] : siteConfigEntry['en']
  return url
}
export const getHowToVideoUrl = (langCode: LangCode, embedded: boolean = true) => {
  const howTo = getLocalizedEntry(siteConfig.video.howTo, langCode)
  return !howTo ? null : buildYoutubeUrl(howTo, embedded)
}
export const getRent2025VideoUrl = (langCode: LangCode, embedded: boolean = true) => {
  const rent2025 = getLocalizedEntry(siteConfig.video.rent2025, langCode)
  return !rent2025 ? null : buildYoutubeUrl(rent2025, embedded)
}
export const getKoalendarUrl = (langCode: LangCode) => {
  const koalendar = getLocalizedEntry(siteConfig.calendar, langCode)
  return !koalendar ? null : 'https://koalendar.com/e/' + koalendar + '?embed=true'
}
